import actions from '../../../../redux/actions/ui/dataImport/strategies/orderStrategy.js'
import BaseStrategy from '../BaseStrategy.js'
import ReconcileForm from './ReconcileForm.js'
import EditForm from './EditForm.js'
import {getNounsFromValue} from '../../../../common/tokenizeOptions.js'

export default function OrderStrategy(props) {
  return (
    <BaseStrategy
      {...props}
      actions={actions}
      EditForm={EditForm}
      ReconcileForm={ReconcileForm}
    />
  )
}

OrderStrategy.title = actions.title
const option = {
  value: 'create_order',
  display: 'Create Orders',
  category: 'orders',
  Component: OrderStrategy,
}
option.nouns = getNounsFromValue(
  `${option.value} ${option.display} ${option.category}`,
)
OrderStrategy.option = option
